import {
    CustomizationSelectionType,
    TCustomizationSelection,
} from "constants/product-customizations/customization-selection.types";
import { textAttributeFontWithUrl } from "../product-customization-template-font-loader";
import React, { useMemo } from "react";
import _ from "lodash";

export interface IText2dOverlayProps {
    selection?: TCustomizationSelection;
    rotation?: number;
}

const overlayStyles = {
    textAlign: "center",
    width: "auto",
    whiteSpace: "nowrap",
} as React.CSSProperties;

export const Text2dOverlay: React.FC<IText2dOverlayProps> = ({ selection, rotation }) => {
    const rotationStyle = useMemo(
        (): React.CSSProperties =>
            !rotation
                ? {}
                : {
                      transformOrigin: "center",
                      transform: `rotate(${rotation})`,
                      msTransform: `rotate(${rotation}deg)`,
                      WebkitTransform: `rotate(${rotation}deg)`,
                  },
        [rotation]
    );

    const fontStyles = useMemo((): React.CSSProperties | object => {
        if (!selection || selection.type !== CustomizationSelectionType.PRINTED_TEXT) {
            return {};
        }

        const nestedValues = selection?.nestedValues || [];

        return nestedValues.reduce((acc, { value, valueKey }) => {
            if (_.includes(["colorPicker", "colorSwatch"], valueKey)) {
                acc.color = value;
            } else if (valueKey === "fontSize") {
                acc.fontSize = +value;
            } else if (valueKey === "font") {
                const font = textAttributeFontWithUrl(value);
                if (font) {
                    acc.fontFamily = font.name;
                    acc.fontStyle = font.style;
                    acc.fontWeight = font.weight;
                }
            }
            return acc;
        }, {} as React.CSSProperties);
    }, [selection]);

    const selectedValue = selection?.value;

    return (
        <div
            style={{
                ...rotationStyle,
                ...fontStyles,
                ...overlayStyles,
            }}
            className="text-overlay"
        >
            {selectedValue ?? null}
        </div>
    );
};
